var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-grey-lighten-1"},[_c('div',{staticClass:"px-4 py-2 text-center"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("eduBB")])]),(_vm.isButtonUpdated)?_c('button',[_vm._v("New Release Available!")]):_c('button',[_vm._v("Current Release")])])
}
var staticRenderFns = []

export { render, staticRenderFns }